import { createSelector } from 'reselect';
import { denormalize } from 'denormalizr';

import { video as videoSchema } from 'shared/schemas';
import { isFree as isVideoFree } from '@wix/wix-vod-shared/src/common/ui-selectors/video/pricing';
import { previewTypes } from '@wix/wix-vod-shared/src/common/constants/preview-types';

function withDealInfoFromSettings(state, video) {
  if (!video) {
    return video;
  }

  // TODO: move to entities reducer
  video.dealInfo = _.isEmpty(video.dealInfo) ? _.get(state, 'vodSettings.dealInfo') : video.dealInfo;
  video.memberOnly = (_.isUndefined(video.memberOnly)) ? _.get(state, 'vodSettings.memberOnly') : video.memberOnly;
  if (_.isEmpty(video.previewType)) {
    video.previewType = isVideoFree(video) ? previewTypes.NONE : previewTypes.FIRST_20_SEC;
  }
  return video;
}

function getStateVideosGroupedByIds(state) {
  return state.entities.videos;
}

export function isNoVideos(state) {
  return _.size(state.entities.videos) === 0;
}

export function isFetching(state) {
  return state.videos.activeRequests !== 0;
}

export function getVideoIds(state) {
  return state.videos.ids;
}

export function getVideoById(state, videoId) {
  return state.entities.videos[videoId];
}

/**
 * @param state
 * @returns {Object[]} channels list
 */
export const getVideos = createSelector(
  [
    state => state,
    getVideoIds,
  ],
  (state, ids) =>
    _.map(ids, _.partial(getVideoById, state)),
);

export const getNewLiveVideoDealInfo = state => ({
  dealInfo: _.get(state, 'vodSettings.dealInfo', []),
  memberOnly: _.get(state, 'vodSettings.memberOnly', false),
});

export const getVideoWithDealInfoFromSettings = createSelector(
  [
    state => state,
    getVideoById,
  ],
  (state, videoData) =>
    withDealInfoFromSettings(state, videoData),
);

/**
 * @param state
 * @param videoId {String}
 * @returns {Object} video
 */
export const getVideoWithChannelDataById = createSelector(
  [
    state => state,
    getVideoById,
  ],
  (state, videoData) =>
    // TODO remove denormalize. Used to add channel data to usedInLists
    withDealInfoFromSettings(state, denormalize(videoData, state.entities, videoSchema)),
);

/**
 * @param state
 * @returns {Object} {id: video}
 */
export const getVideosGroupedByIds = createSelector(
  [
    state => state,
    getStateVideosGroupedByIds,
  ],
  (state, videosByIds) =>
    _.mapValues(videosByIds, _.partial(withDealInfoFromSettings, state)),
);


/**
 * @param state
 * @param ids {String[]}
 * @returns {Object[]} videos list
 */
export const getVideosByIds = createSelector(
  [
    getVideosGroupedByIds,
    (state, ids) => ids,
  ],
  _.pick,
);

export const areAllVideosFree = createSelector(
  getVideosGroupedByIds,
  videos => _.every(videos, isVideoFree)
);

/**
 * @param state
 * @param ids {String[]}
 * @param currentVideoId {String}
 * @returns {Object[]} videos list
 */
export const getVideosByIdsWithoutCurrent = createSelector(
  [
    getVideosByIds,
    (state, ids, currentVideoId) => currentVideoId,
  ],
  _.omit,
);


/**
 * @param state
 * @param props {String[]}
 * @returns {Object} {id: videoProps}
 */
export const getVideosGroupedByIdsProps = createSelector(
  [
    getVideosGroupedByIds,
    (state, props) => props,
  ],
  (videosByIds, props = []) =>
    _.mapValues(videosByIds, video => _.pick(video, ['id', ...props])),
);



// WEBPACK FOOTER //
// ./src/shared/selectors/videos.js